import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export type ObserveWallet = {
  chainCode: string;
  address: string;
  name: string;
};

interface StoreState {
  walletList: ObserveWallet[];
  hideRiskNft: boolean;
}

type Action = {
  addWallet: (list: ObserveWallet) => any;
  removeWallet: (list: ObserveWallet) => any;
  updateWallet: (list: ObserveWallet) => any;
  isExist: (name: string, address: string) => boolean;
  isMax: () => boolean;
  getAllObserveWallet: () => ObserveWallet[];
  setHideRisk: (is: boolean) => any;
};

const useObserveStore = create(
  persist<StoreState & Action>(
    (set, get) => ({
      hideRiskNft: true,
      walletList: [] as ObserveWallet[],
      addWallet: (wallet: ObserveWallet) =>
        set((state) => {
          return { walletList: [...state.walletList, wallet] };
        }),
      setHideRisk: (is: boolean) => {
        set(() => {
          return { hideRiskNft: is };
        });
      },
      removeWallet: (wallet: ObserveWallet) => {
        set((state) => {
          state.walletList.splice(
            state.walletList.findIndex(
              (item) =>
                item.address === wallet.address &&
                item.chainCode === wallet.chainCode
            ),
            1
          );
          return { walletList: state.walletList };
        });
      },
      updateWallet: (wallet: ObserveWallet) =>
        set((state) => {
          const wal = state.walletList.find(
            (item) =>
              item.address === wallet.address &&
              item.chainCode === wallet.chainCode
          );
          if (wal) {
            wal.name = wallet.name;
          }
          return { walletList: state.walletList };
        }),
      isExist(name: string, address: string) {
        return !!get().walletList.find(
          (item) => item.name === name || item.address === address
        );
      },
      isMax() {
        return get().walletList.length >= 21;
      },
      getAllObserveWallet() {
        return get().walletList;
      },
    }),
    { name: 'ob' }
  )
);

export default useObserveStore;
